module.exports = __webpack_public_path__ + "img/goback.e01fdeaf.jpg";